module.exports = __webpack_public_path__ + "static/media/title.15f0aa91.png";